

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-labeled-content {
  &::part(content) {
    white-space: initial;
  }

  &::part(label) {
    --font-family: var(--font-family-secondary);
  }
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width {
    width: 500px;
  }

  gz-checkbox {
    --form-field-input-width: 500px;
  }
}

gz-policy-panel-antimalware-security-servers-sva-ips-table {
  margin-top: -25px;
}
